import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Button, FormControl, Grid, TextField, Typography } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { getDocument as getDocumentService } from "../../services/backend/ExpedientService";
import { getFiled } from "../../services/backend/CorrespondenceService";
import FiledCancellationNotice from "../filed/FiledCancellationNotice";
import { sourceFiledIdOf } from "./expedientCancellation";

const DocumentView = () => {
  const user = useSelector((state) => state.user.value);
  const { documentId } = useParams();
  const [document, setDocument] = useState();
  // The annulled radicado this document is a copy of, if any.
  const [annulledSource, setAnnulledSource] = useState(null);

  useEffect(() => {
    const getDocument = async () => {
      const response = await getDocumentService(documentId, user);
      setDocument(response);
      if (!response) return;
      if (response.cancellation) {
        setAnnulledSource({ ...response, filedId: response.cancellation.sourceFiledId || null });
        return;
      }
      // Not marked (cloned after the annulment, or marking failed): ask the
      // radicado itself. Only the document copy names it; an annex doesn't.
      const filedId = response.documentType === "Comunicaciones Oficiales" ? sourceFiledIdOf(response) : null;
      if (!filedId) return;
      const filed = await getFiled(user.token, filedId);
      if (filed?.status === "CANCELLED") setAnnulledSource(filed);
    };

    if (!document) getDocument();
  }, [documentId]); // eslint-disable-line

  if (!document) return null;
  return (
    <Box sx={{ my: 2, mx: "auto", maxWidth: 800, backgroundColor: "#f9f9f9", padding: 2, borderRadius: 3 }}>
      {annulledSource && (
        <FiledCancellationNotice filed={annulledSource} title="COPIA DE UN RADICADO ANULADO" linkToFiled />
      )}
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h6">
            {document.name}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <FormControl fullWidth sx={{ marginY: 1 }}>
            <TextField
              label="Expediente"
              value={document.expedientId}
              disabled={true}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl required fullWidth sx={{ marginY: 1 }}>
            <TextField
              label="Formato de documento"
              value={document.documentFormat}
              disabled={true}
            />
          </FormControl>
        </Grid>
        <Grid item xs={8}>
          <FormControl fullWidth sx={{ marginY: 1 }}>
            <TextField
              label="Nombre del documento"
              value={document.documentName}
              disabled={true}
            />
          </FormControl>
        </Grid>
        <Grid item xs={9}>
          <FormControl fullWidth sx={{ marginY: 1 }}>
            <TextField
              label="Tipo de documento"
              value={document.documentType}
              disabled={true}
            />
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <FormControl fullWidth sx={{ marginY: 1 }}>
            <TextField
              label="Folios"
              value={document.folios}
              disabled={true}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth sx={{ marginY: 1 }}>
            <TextField
              multiline
              rows={5}
              label="Metadatos"
              disabled={true}
              defaultValue={document.metadata && Object.keys(document.metadata).map(
                (key) => `${key}: ${document.metadata[key]}`
              ).join("\n")}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth sx={{ marginY: 1 }}>
            <TextField
              multiline
              rows={5}
              label="Palabras claves"
              disabled={true}
              defaultValue={document.keywords?.map(
                (keyword) => `${keyword}`
              ).join("\n")}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Box>
            <a href={document.documentUrl} target="_blank" rel="noreferrer">
              <Button variant="contained">
                Ver documento <OpenInNewIcon size={20} />
              </Button>
            </a>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default DocumentView;
